import { useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { convertTo12HourFormat } from "../../../utils/Helper";
export const usePunctuality = () => {
    const [popupOpne, setPopupOpen] = useState(false);
    const [DateRange, setDateRange] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [leadOptions, setLeadOptions] = useState([]);
    const [loader, setLoader] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [isChanged, setIsChanged] = useState(false);
    const [userCode, setUserCode] = useState('');
    const [punctuality, setPunctuality] = useState({});
    const [attendanceSummary, setAttandanceSummary] = useState([]);
    const [filterValues, setFilterValues] = useState({
        selectedUsers: [],
        selectedLead: [],
        month: [],
        year: [new Date().getFullYear()],
        view_group_wise: false,
        apiCall: false,
    });
    const [rowData, setRowData] = useState([])
    const [columnDefs, setColumnDefs] = useState([]);
    const [summaryLoader, setSummaryLoader] = useState([]);
    useEffect(() => {
        setColumnDefs([
            {
                headerName: "Sr No.",
                hide: filterValues?.view_group_wise,
                valueGetter: (params) => {
                    return params.node?.id != null
                        ? parseInt(params?.node?.id) + 1
                        : "";
                },
                cellStyle: { textAlign: "center" },
                width: 50,
                pinned: "left"
            },
            {
                field: "group_name",
                headerName: "Group Name",
                rowGroup: filterValues?.view_group_wise,
                hide: true,
                width: 150,
            },
            {
                headerName: "Employee Name",
                field: "user_display_name",
                minWidth: 110,
                width: "19%",
            },
            {
                headerName: "Employee ID",
                field: "employee_id",
                minWidth: 90,
                width: "12%",
                cellStyle: { textAlign: "center" },
                headerClass: "ag-text-center"
            },
            {
                headerName: "Shift Date",
                field: "shift_date",
                minWidth: 90,
                width: "12%",
                cellStyle: { textAlign: "center" },
                headerClass: "ag-text-center"
            },
            {
                headerName: "Shift Time",
                field: "shift_time",
                minWidth: 90,
                width: "12%",
                cellStyle: { textAlign: "center" },
                headerClass: "ag-text-center"
            },
            {
                headerName: "In Time",
                field: "in_time",
                minWidth: 90,
                width: "12%",
                cellStyle: { textAlign: "center" },
                headerClass: "ag-text-center",
                cellRenderer: function (params) {
                    return (
                        <div style={{ background: params?.data?.is_late_in ? "#ff9292" : "", color: params?.data?.is_late_in ? "#fff" : "", borderRadius: '30px', lineHeight: '24px', marginTop: '2px' }}>
                            {params?.data?.in_time && convertTo12HourFormat(params?.data?.in_time)}
                        </div>
                    );
                },
            },
            {
                headerName: "Out Time",
                field: "out_time",
                minWidth: 90,
                width: "12%",
                cellStyle: { textAlign: "center" },
                headerClass: "ag-text-center",
                cellRenderer: function (params) {
                    return (
                        <div style={{ background: params?.data?.is_early_out ? "#ff9292" : "", color: params?.data?.is_early_out ? "#fff" : "", borderRadius: '30px', lineHeight: '24px', marginTop: '2px' }}>
                            {params?.data?.out_time && convertTo12HourFormat(params?.data?.out_time)}
                        </div>
                    );
                },
            },
            {
                headerName: "In Reason",
                field: "in_remark",
                minWidth: 300,
                width: "40%",
                cellRenderer: function (params) {
                    return (
                        <div>
                            {
                                params?.value && <p title={params?.value}>{params?.value}</p>
                            }
                        </div>
                    );
                },
            },
            {
                headerName: "Out Reason",
                field: "out_remark",
                minWidth: 300,
                width: "40%",
                cellRenderer: function (params) {
                    return (
                        <div>
                            {
                                params?.value && <p title={params?.value}>{params?.value}</p>
                            }
                        </div>
                    );
                },
            },
        ])
        // eslint-disable-next-line
    }, [userCode, filterValues?.view_group_wise])

      useEffect(() => {
        callautopopulate("users", "project_leads", "user_info").then((res) => {
            const userOption = res?.users
                ?.map((user) => ({
                    label: user.user_display_name,
                    value: user.user_code,
                }))
                .sort((a, b) => a.label?.localeCompare(b.label));
            setUserOptions(userOption);
            setLeadOptions(res?.project_leads);
            const data = _.filter(res?.project_leads, { user_code: res?.user_info?.[0]?.user_code });
            setFilterValues((prev) => ({ ...prev, selectedLead: data, view_group_wise: res?.user_info?.[0]?.is_user_grouping_view }));
            // setCurrentUser(res?.user_info?.[0]?.user_code)
            setUserCode(res?.user_info?.[0]?.user_code);
        });
        // eslint-disable-next-line
    }, [])


    // this function use for remove state value when click on close
    // eslint-disable-next-line
    const handleEvents = (data, type) => {
        if (type === "year") {
            setFilterValues((prev) => ({ ...prev, year: [] }));
        }
        if (type === "month") {
            setFilterValues((prev) => ({ ...prev, month: [] }));
        }
        if (type === "leads") {
            setFilterValues((prev) => ({ ...prev, selectedLead: [] }));
        }
        if (type === "users") {
            setFilterValues((prev) => ({ ...prev, selectedUsers: [] }))
        }
        setIsChanged(true)
    }
    // this API calling get the employee punctuality data based on filter
    // eslint-disable-next-line
    const GetEmployeeAttandance = async (user, key, refresh) => {
        setLoader(true);
        try {
            const payload = {
                "project_lead_user_code": key === "widget" ? "" : _.pluck(filterValues?.project_leads, "user_code").toString(),
                "requested_user_code": _.pluck(filterValues.users, 'user_code').toString(),
                "from_date": (DateRange && DateRange[0] !== undefined) ? (new Date(DateRange[0])).toISOString().slice(0, 10) : '',
                "to_date": (DateRange && DateRange[1] !== undefined) ? (new Date(DateRange[1])).toISOString().slice(0, 10) : '',
                "year": filterValues?.year?.length > 0 ? filterValues.year?.toString() : "",
                "month": filterValues?.month?.length > 0 ? filterValues.month?.toString() : ""
            }

            const res = await services.getInvokeRemote("POST", Urls("GETEMPLOYEEPUNCTUALITY"), payload)
            if (res?.body?.data) {
                setRowData(res?.body?.data?.employee_attendance);
                if (refresh) {
                    await callautopopulate("user_info")?.then(res => {
                        setFilterValues((prev) => ({ ...prev, view_group_wise: res?.user_info?.[0]?.is_user_grouping_view || false }));
                    })
                }
            }
            setLoader(false);
            setIsChanged(false)
        }
        catch (error) {
            setLoader(false);
            console.error("Error: ", error);
        }
    }

    // this API calling get the employee punctuality summary based on filter
    // eslint-disable-next-line
    const GetEmployeeAttandanceSummary = async (key) => {
        setSummaryLoader(true);
        try {
            const payload = {
                "project_lead_user_code": key === "widget" ? "" : _.pluck(filterValues?.project_leads, "user_code").toString(),
                "requested_user_code": _.pluck(filterValues.users, 'user_code').toString(),
                "from_date": (DateRange && DateRange[0] !== undefined) ? (new Date(DateRange[0])).toISOString().slice(0, 10) : '',
                "to_date": (DateRange && DateRange[1] !== undefined) ? (new Date(DateRange[1])).toISOString().slice(0, 10) : '',
                "year": filterValues?.year?.length > 0 ? filterValues.year?.toString() : "",
                "month": filterValues?.month?.length > 0 ? filterValues.month?.toString() : ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETEMPLOYEEPUNCTUALITYSUMMARY"), payload)
            if (res?.body?.data) {
                const data = res?.body?.data?.employee_vise_punctuality
                setPunctuality(res?.body?.data?.employee_punctuality?.[0])
                const userData = _.every(data, function (item) {
                    return item.user_code === userCode;
                });
                if (!userData) {
                    setAttandanceSummary(data)
                } else {
                    setAttandanceSummary([])
                }
            }
            setSummaryLoader(false);
            setIsChanged(false)
        }
        catch (error) {
            setSummaryLoader(false);
            console.error("Error: ", error);
        }
    }
   
    useEffect(() => {
        if (!filterValues.apiCall) return;

        GetEmployeeAttandance();
        GetEmployeeAttandanceSummary();
        setFilterValues((prev) => ({ ...prev, apiCall: false }));
    }, [filterValues.apiCall, GetEmployeeAttandance, GetEmployeeAttandanceSummary]);

    return useMemo(() => ({
        summaryLoader, popupOpne, setPopupOpen, DateRange, setDateRange, userOptions, leadOptions, filterValues, setFilterValues, handleEvents, columnDefs, loader, rowData, GetEmployeeAttandance, selectedData, setSelectedData, attendanceSummary, GetEmployeeAttandanceSummary, isChanged, setIsChanged, punctuality, userCode
    }), [summaryLoader, popupOpne, setPopupOpen, DateRange, setDateRange, userOptions, leadOptions, filterValues, setFilterValues, handleEvents, columnDefs, loader, rowData, GetEmployeeAttandance, selectedData, setSelectedData, attendanceSummary, GetEmployeeAttandanceSummary, isChanged, setIsChanged, punctuality, userCode])
}